module.exports = __webpack_public_path__ + "static/img/tsg.9859120.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tsg.jpg
// module id = OG7d
// module chunks = 46